import { TxDetail } from '@apm/contracts';
import { toQuery } from '../api';
import { useQuery } from '../hooks/useQuery';

/** `GET /api/tx/:traceId` 응답. 봉투는 계약에 있다 (17회차) */
export type { TxDetail };

export interface TxDetailState {
  loading: boolean;
  detail?: TxDetail;
  error?: string;
  /** `detail`이 앞 주소(다른 요청·다른 서비스 줄)의 답이다. 그리지 않는다 (44회차) */
  stale: boolean;
}

/**
 * 요청 상세 하나를 받아 온다 (7회차 결정 3).
 *
 * 주소(`#/tx/{요청 번호}`)로 바로 들어와도 화면이 서므로 스토어를 거치지 않고 직접 조회한다.
 * `svc=`가 있으면 같은 요청 번호 중 그 서비스 줄을 읽는다. 전역 선택과 분리돼 헤더를 바꿔도
 * 상세가 다른 줄로 바뀌거나 404가 되지 않는다. `tx=`가 있으면 같은 서비스의 줄 중 그 실행을
 * 읽는다 (D41-5).
 */
export function useTxDetail(
  traceId: string,
  service?: string,
  txId?: string,
  /** 요청 시작 시각. 서버가 저장 파일을 그날 앞뒤만 연다 (59회차) */
  at?: number,
): TxDetailState {
  const { loading, data, error, stale } = useQuery(
    `/api/tx/${traceId}${toQuery({ service, txId, at })}`,
    TxDetail,
  );
  return { loading, detail: data, error, stale };
}
